import { UPDATE_CAMPAIGNS_GROUPS_SUCCESS } from './actionTypes';

export const updateCampaignsGroupsSuccess = campaignsGroups => ({
    type: UPDATE_CAMPAIGNS_GROUPS_SUCCESS,
    payload: campaignsGroups,
});
